import React, { useEffect, useState } from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Input from '@deprecated-ui/common/Input';
import { useDispatch, useSelector } from 'react-redux';
import valuationSlice, {
  valuationEffects,
  valuationSelectors,
} from 'features/valuation/slice';
import { effects as valuationWidgetEffects } from 'global/MainLayout/SideWidget/Valuation/slice';

import handleErrorMessageAPI from 'global/AlertErrorMessage';
import SUCCESS_MESSAGE from 'constants/successMessage';
import Modal from '../../Modal';
import {
  Label,
  StockValueContainer,
  ConsensusTargetContainer,
  NoteContainer,
} from '../styled';

const { TextArea } = Input;

const ValuationResult = () => {
  const [note, setNote] = useState<string>('');
  const [isModalSaveVisible, setIsModalSaveVisible] = useState<boolean>(false);
  const [isModalOverwriteVisible, setIsModalOverwriteVisible] =
    useState<boolean>(false);

  const dispatch = useDispatch();

  const {
    valuationResult,
    valuationSymbol,
    valuationCreateTemplateResult,
    valuationUpdateTemplateResult,
    valuationDetail,
    metric,
    note: valuationNote,
  } = useSelector(valuationSelectors);

  const { setValuationNote } = valuationSlice.actions;

  const {
    createValuationTemplete,
    getValuationDetailTemplate,
    updateValuationDetailTemplate,
  } = valuationEffects;

  const { getValuationTemplate: getValuationList } = valuationWidgetEffects;

  const {
    symbol,
    target_price: targetPrice,
    current_price: currentPrice,
    margin_safety: marginSafety,
    consensus_high: consensusHigh,
    consensus_medium: consensusMedium,
    consensus_low: consensusLow,
  } = valuationResult.data;

  const onInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setNote(value);
  };

  const onCancelModal = () => {
    setIsModalSaveVisible(false);
    setIsModalOverwriteVisible(false);
  };

  const onClickSave = () => {
    const { data } = valuationCreateTemplateResult;
    const { data: dataValuation } = valuationDetail;

    if (
      Object.keys(data).length === 0 &&
      Object.keys(dataValuation).length === 0
    ) {
      setIsModalSaveVisible(true);
    } else {
      setIsModalOverwriteVisible(true);
    }
  };

  const generateResult = () => {
    const { data } = valuationResult;
    const normalizeData = JSON.parse(JSON.stringify(data));

    delete normalizeData.symbol;
    delete normalizeData.symbol_2;
    delete normalizeData.symbol_3;
    delete normalizeData.country;
    delete normalizeData.exchange;

    return Object.keys(normalizeData).map((el) => ({
      name: el,
      value: normalizeData[el],
    }));
  };

  const onClickSaveOnModal = async (valuationName?: string) => {
    const { data } = valuationDetail;
    const { id: companyID } = valuationSymbol;

    const result = generateResult();

    const payload = {
      company_id: companyID,
      name: valuationName,
      note,
      metric: JSON.stringify(metric),
      result: JSON.stringify(result),
    };

    // save valuation if no previous data available
    if (Object.keys(data).length === 0) {
      const resp = await dispatch(createValuationTemplete({ payload }));
      // @ts-ignore
      const { data: dataValuation } = await resp.payload;
      dispatch(setValuationNote(note));
      if (dataValuation) setIsModalSaveVisible(false);
    } else {
      // if previous data available, do update instead
      const {
        valuation: { name, id },
      } = data;
      payload.name = name;

      // Delete company id upon update
      delete payload.company_id;

      // @ts-ignore
      dispatch(updateValuationDetailTemplate({ payload, templateID: id })).then(
        () => {
          handleErrorMessageAPI(
            'Your template has been updated',
            SUCCESS_MESSAGE.ALERT_GREEN,
          );
          dispatch(getValuationList());
        },
      );
      dispatch(setValuationNote(note));
      setIsModalOverwriteVisible(false);
    }
  };

  const getValuationDetail = () => {
    const { data } = valuationCreateTemplateResult;
    const { id } = data;

    dispatch(getValuationDetailTemplate(id));
  };

  useEffect(() => {
    const { data } = valuationCreateTemplateResult;

    if (Object.keys(data).length) {
      dispatch(getValuationList());
      getValuationDetail();
    }
  }, [valuationCreateTemplateResult]);

  useEffect(() => {
    if (valuationNote !== undefined) {
      setNote(valuationNote);
    }
  }, [valuationNote]);

  return (
    <>
      <StockValueContainer>
        {/* @ts-expect-error */}
        <Label mb="16px">Stock Value</Label>
        {/* @ts-expect-error */}
        <Flex mb="10px" justify="space-between" width="100%">
          <Text width="50%">Target Price {symbol}</Text>
          <Text width="50%">{targetPrice}</Text>
        </Flex>
        {/* @ts-expect-error */}
        <Flex mb="10px" justify="space-between" width="100%">
          <Text width="50%">Current Price {symbol}</Text>
          <Text width="50%">{currentPrice}</Text>
        </Flex>
        {/* @ts-expect-error */}
        <Flex mb="10px" justify="space-between" width="100%">
          <Text width="50%">Potential Gain</Text>
          <Text width="50%">{`${marginSafety} %`}</Text>
        </Flex>
      </StockValueContainer>
      <ConsensusTargetContainer>
        {/* @ts-expect-error */}
        <Label mb="16px">Consensus Target</Label>
        {/* @ts-expect-error */}
        <Flex mb="10px" justify="space-between" width="100%">
          <Text width="50%">Consensus (High)</Text>
          <Text width="50%">{consensusHigh}</Text>
        </Flex>
        {/* @ts-expect-error */}
        <Flex mb="10px" justify="space-between" width="100%">
          <Text width="50%">Consensus (Medium)</Text>
          <Text width="50%">{consensusMedium}</Text>
        </Flex>
        {/* @ts-expect-error */}
        <Flex mb="10px" justify="space-between" width="100%">
          <Text width="50%">Consensus (Low)</Text>
          <Text width="50%">{consensusLow}</Text>
        </Flex>
      </ConsensusTargetContainer>
      <NoteContainer>
        {/* @ts-expect-error */}
        <Label mb="16px">Notes</Label>
        {/* @ts-expect-error */}
        <TextArea rows={3} value={note} onChange={onInput} />
      </NoteContainer>
      <Button width="50px" type="primary" onClick={onClickSave}>
        Save
      </Button>

      <Modal
        modalTitle="Save New Valuation"
        cancelText="CANCEL"
        isVisible={isModalSaveVisible}
        okText="SAVE"
        onClickCancel={onCancelModal}
        onClickOk={(value) => {
          onClickSaveOnModal(value);
        }}
      />

      <Modal
        modalTitle="Overwrite Valuation?"
        cancelText="CANCEL"
        isVisible={isModalOverwriteVisible}
        okText="UPDATE"
        onClickCancel={onCancelModal}
        isOverrideMode
        initValuationName={valuationDetail.data?.valuation?.name}
        onClickOk={(value) => {
          onClickSaveOnModal(value);
        }}
      />
    </>
  );
};

export default ValuationResult;
